import React from 'react';
import { Modal } from '../../components/modals/antd-modals';
import { BasicFormWrapper } from '../styled';
import { Button } from '../../components/buttons/buttons';

const DeleteElectricityPriceModal = ({ visible, onCancel, handleDelete, electricityPrice }) => {
  return electricityPrice ? (
    <Modal
      visible={visible}
      type="primary"
      title="Delete Electricity Price"
      onCancel={onCancel}
      footer={[
        <div key="date-electricity-price" className="car-modal-footer">
          <Button size="default" type="danger" key="submit" onClick={() => handleDelete(electricityPrice._id)}>
            Delete Electricity Price
          </Button>
          <Button size="default" type="white" key="black" outlined="true" onClick={onCancel}>
            Cancel
          </Button>
        </div>,
      ]}
    >
      <div className="car-modal">
        <BasicFormWrapper>
          <p>Delete Electricity Price ?</p>
        </BasicFormWrapper>
      </div>
    </Modal>
  ) : (
    <></>
  );
};

export default DeleteElectricityPriceModal;
